/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupePlusIcon16Regular = forwardRef('SearchLoupePlusIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.75 4.75a.75.75 0 1 0-1.5 0v1.5h-1.5a.75.75 0 1 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 1 0 0-1.5h-1.5v-1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.996 13.246a6.223 6.223 0 0 0 3.857-1.332l2.854 2.853a.75.75 0 1 0 1.06-1.06l-2.853-2.854a6.25 6.25 0 1 0-4.918 2.393Zm0-11a4.75 4.75 0 1 0 3.313 8.153.785.785 0 0 1 .09-.09 4.75 4.75 0 0 0-3.403-8.063Z" })));
});
